module.exports = __webpack_public_path__ + "static/media/trello.7554030c.svg";